import { render, staticRenderFns } from "./room-type-detail.vue?vue&type=template&id=66a843e7&"
import script from "./room-type-detail.vue?vue&type=script&lang=js&"
export * from "./room-type-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports